import { useState } from "react";
import { Zap, Phone, Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { PHONE_TEL } from "./data";

const links = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "About", id: "about" },
  { label: "Areas", id: "areas" },
  { label: "Contact", id: "contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 md:h-[72px] flex items-center justify-between">
        <button
          data-testid="header-logo"
          onClick={() => go("home")}
          className="flex items-center gap-2.5 focus:outline-none focus:ring-2 focus:ring-blue-600 rounded-md"
        >
          <span className="w-9 h-9 bg-blue-600 rounded-md flex items-center justify-center">
            <Zap className="w-5 h-5 text-amber-400" fill="currentColor" />
          </span>
          <span className="font-heading leading-none text-left">
            <span className="block text-base md:text-lg font-bold tracking-tight text-slate-900">
              Essex Spark
            </span>
            <span className="block text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">
              Electrical
            </span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8" data-testid="header-nav">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => go(l.id)}
              className="text-sm font-semibold text-slate-600 hover:text-slate-900 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-600 rounded-sm"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <a
            data-testid="header-call-button"
            href={PHONE_TEL}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-slate-300 text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
            aria-label="Call now"
          >
            <Phone className="w-4 h-4" />
          </a>
          <button
            data-testid="header-quote-button"
            onClick={() => go("contact")}
            className="hidden md:inline-flex bg-blue-600 hover:bg-blue-700 text-white text-sm font-bold px-6 py-3 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2"
          >
            Get a Quote
          </button>
          <button
            data-testid="header-menu-button"
            onClick={() => setOpen(!open)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
            aria-label="Toggle menu"
            aria-expanded={open}
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-slate-200 px-5 py-4 flex flex-col gap-1"
        >
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}-link`}
              onClick={() => go(l.id)}
              className="text-left text-base font-semibold text-slate-800 py-3 border-b border-slate-100 last:border-0 focus:outline-none focus:ring-2 focus:ring-blue-600 rounded-sm"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-menu-quote-button"
            onClick={() => go("contact")}
            className="mt-3 bg-blue-600 text-white text-sm font-bold px-6 py-3.5 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
          >
            Get a Quote
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
